import React from 'react';
import FormStep from "../form-step";
import {Field, Form} from "formik";
import {renderField} from "../../../../utils/form-utils";
import * as Yup from "yup";
import ActionButtons from "../action-buttons";
import {CheckboxListField} from "../checkbox-list-field";
import StepLayout from "../step-layout";

const validationSchema = Yup.object().shape({
    off_cloud_workloads: Yup.string().required('Required'),
    off_cloud_workloads_hosting: Yup.array(Yup.string()).when('off_cloud_workloads', {
        is: 'Yes',
        then: Yup.array(Yup.string()).min(1, 'Select at least one').required('Required')
    }),
    off_cloud_workloads_count: Yup.string().when('off_cloud_workloads', {
        is: 'Yes',
        then: Yup.string().required('Required')
    }),
    off_cloud_workloads_annual_spend: Yup.string(),
    // ocwAnnualSpend: Yup.string().when('off_cloud_workloads_count', (ocwCount) => {
    //     if (ocwCount !== "I don't know" && ocwCount !== "")
    //         return Yup.string().required()
    // }),
    off_cloud_workloads_in_production: Yup.string().when('off_cloud_workloads', {
        is: 'Yes',
        then: Yup.string().required('Required')
    }),
    off_cloud_workloads_type: Yup.array(Yup.string()).when('off_cloud_workloads', {
        is: 'Yes',
        then: Yup.array(Yup.string()).min(1, 'Select at least one').required('Required')
    }),
});

const OffCloudWorkloads = ({data, onNext}) => {
    const initialValues = {
        off_cloud_workloads: data.off_cloud_workloads || '',
        off_cloud_workloads_hosting: data.off_cloud_workloads_hosting || [],
        off_cloud_workloads_count: data.off_cloud_workloads_count || '',
        off_cloud_workloads_annual_spend: data.off_cloud_workloads_annual_spend || '',
        off_cloud_workloads_in_production: data.off_cloud_workloads_in_production || '',
        off_cloud_workloads_type: data.off_cloud_workloads_type || [],
    };

    return (
        <FormStep
            name="Workloads outside of the Cloud"
            initialValues={initialValues}
            validationSchema={validationSchema}
            onNext={onNext}
        >
            {({
                  values
              }) => (
                <StepLayout actions={<ActionButtons/>}>
                    <Field
                        type="select"
                        name="off_cloud_workloads"
                        component={renderField}
                        label="Are you running workloads outside of the Cloud?"
                    >
                        <option value="">-- Please Select --</option>
                        <option value="Yes">Yes</option>
                        <option value="No / I don't know">No / I don't know</option>
                    </Field>

                    {values.off_cloud_workloads === 'Yes' &&
                    <>
                        <CheckboxListField
                            name="off_cloud_workloads_hosting"
                            items={["Datacenter", "Collocation", "In-house", "Other", "I don't know"]}
                            label="Where are they hosted?"
                        />

                        <Field
                            type="select"
                            name="off_cloud_workloads_count"
                            component={renderField}
                            label="How many workloads do you have?"
                        >
                            <option value="">-- Please Select --</option>
                            <option value="Less than 100">Less than 100</option>
                            <option value="100-500">100-500</option>
                            <option value="500-1000">500-1000</option>
                            <option value="1000+">1000+</option>
                            <option value="I don't know">I don't know</option>
                        </Field>

                        {values.off_cloud_workloads_count !== "I don't know" &&
                        <Field
                            type="select"
                            name="off_cloud_workloads_annual_spend"
                            component={renderField}
                            label="What is your current annual spend?"
                        >
                            <option value="">-- Please Select --</option>
                            <option value="Under $250K">Under $250K</option>
                            <option value="$250K-$1M">$250K-$1M</option>
                            <option value="$1M+">$1M+</option>
                            <option value="I don't know">I don't know</option>
                        </Field>
                        }

                        <Field
                            type="select"
                            name="off_cloud_workloads_in_production"
                            component={renderField}
                            label="Are you in Production?"
                        >
                            <option value="">-- Please Select --</option>
                            <option value="Yes">Yes</option>
                            <option value="Yes">No</option>
                        </Field>

                        <CheckboxListField
                            name="off_cloud_workloads_type"
                            items={[
                                "Linux", "Windows", "Serverless", "Containers",
                                "Big Data", "Analytics", "Gaming", "IoT",
                                "Mobile", "AI/ML", "Storage", "Other",
                                "I don't know"
                            ]}
                            label="What type of workloads are you running?"
                        />

                    </>
                    }
                </StepLayout>
            )}
        </FormStep>
    )
}

export default OffCloudWorkloads